/*
 * "Veja na prática" — abre o vídeo do card em um modal.
 *
 * O player só é criado no clique (e destruído ao fechar) para não carregar
 * N iframes do YouTube / N vídeos da Shopify junto com a home.
 */
class VejaPraticaSection extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('[data-vp-modal]');
    this.dialog = this.querySelector('[data-vp-dialog]');
    if (!this.modal || !this.dialog) return;

    this.onKeydown = this.handleKeydown.bind(this);

    this.querySelectorAll('[data-vp-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.open(trigger));
    });

    this.querySelector('[data-vp-close]')?.addEventListener('click', () => this.close());
    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) this.close();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    document.body.style.overflow = '';
  }

  open(trigger) {
    const { vpType, vpSrc } = trigger.dataset;
    if (!vpSrc) return;

    this.lastTrigger = trigger;
    this.dialog.innerHTML = '';
    this.modal.classList.toggle('veja-pratica-modal--landscape', trigger.dataset.vpOrientation === 'landscape');

    if (vpType === 'external') {
      const iframe = document.createElement('iframe');
      iframe.src = vpSrc;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = trigger.dataset.vpTitle || '';
      this.dialog.appendChild(iframe);
    } else {
      const video = document.createElement('video');
      video.src = vpSrc;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      if (trigger.dataset.vpPoster) video.poster = trigger.dataset.vpPoster;
      this.dialog.appendChild(video);
    }

    this.modal.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.onKeydown);
    this.querySelector('[data-vp-close]')?.focus();
  }

  close() {
    // Esvaziar o container para o vídeo/iframe parar de tocar em segundo plano.
    this.dialog.innerHTML = '';
    this.modal.removeAttribute('open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.onKeydown);
    this.lastTrigger?.focus();
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.close();
  }
}

if (!customElements.get('veja-pratica-section')) {
  customElements.define('veja-pratica-section', VejaPraticaSection);
}
